// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The source's identity block inside the shared detail header.
 *
 * Only what the header does not already own: the header supplies the title,
 * subtitle, actions and all of the surrounding geometry.
 */
.D7x1pUzlYIvHqO3MA_uD {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-top: 10px;
  min-width: 0;
}

.h3eysZ_EyRNJe8vnmhKW {
  margin: 0;
  max-width: 720px;
  font-size: var(--curio-font-size-md);
  color: var(--curio-text-secondary);
  line-height: 1.5;
}

._E5VVssZ_v5QmcwhypFU {
  min-width: 0;
}

.K235mtdzVpdt2CpjC6Ze {
  display: inline-block;
  margin-top: 4px;
  font-size: var(--curio-font-size-xs);
  color: var(--curio-text-secondary);
}

.qbpdT2dbWvX1lt_IowAl {
  font-size: var(--curio-font-size-sm);
  color: var(--curio-text-meta);
}

/* A storage source's Rescan: light with a border, a secondary action beside
   the search box. */
.S6Evzph8Vc7CISxoAMkh {
  height: 30px;
  margin-left: 10px;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-md);
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  padding: 0 12px;
  font-family: inherit;
  font-size: var(--curio-font-size-sm);
  font-weight: 600;
  cursor: pointer;
}

.S6Evzph8Vc7CISxoAMkh:disabled {
  opacity: 0.6;
  cursor: progress;
}

/* Below a portal's rows: asks it for its next page. */
.KRLqo6Ih5epgbuo1brnN {
  display: flex;
  justify-content: center;
  padding: 12px 16px;
}

.KRLqo6Ih5epgbuo1brnN .S6Evzph8Vc7CISxoAMkh {
  margin-left: 0;
}

/* For the manifest's author: what the source holds that no resource names. */
.IWSM1dwj1WBNWVZ4nKRR {
  margin: 0;
  padding: 8px 16px;
  font-size: var(--curio-font-size-sm);
  color: var(--curio-text-meta);
}

/* The result list: rows on a card surface, bounded so the page scrolls its
   results rather than the whole document. */
.WFerYmCorbIAPWwF2udI {
  background: var(--curio-card-bg);
  border-top: 1px solid var(--curio-border);
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/discovery/DiscoverySourceDetail.module.css"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;oBACoB;AACpB;EACE,YAAY;EACZ,iBAAiB;EACjB,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,6EAA6E;AAC7E;EACE,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;4CAC4C;AAC5C;EACE,gCAAgC;EAChC,yCAAyC;EACzC,gBAAgB;EAChB,OAAO;EACP,aAAa;AACf","sourcesContent":["/*\n * The source's identity block inside the shared detail header.\n *\n * Only what the header does not already own: the header supplies the title,\n * subtitle, actions and all of the surrounding geometry.\n */\n.identity {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  margin-top: 10px;\n  min-width: 0;\n}\n\n.blurb {\n  margin: 0;\n  max-width: 720px;\n  font-size: var(--curio-font-size-md);\n  color: var(--curio-text-secondary);\n  line-height: 1.5;\n}\n\n.identityText {\n  min-width: 0;\n}\n\n.homepage {\n  display: inline-block;\n  margin-top: 4px;\n  font-size: var(--curio-font-size-xs);\n  color: var(--curio-text-secondary);\n}\n\n.count {\n  font-size: var(--curio-font-size-sm);\n  color: var(--curio-text-meta);\n}\n\n/* A storage source's Rescan: light with a border, a secondary action beside\n   the search box. */\n.rescan {\n  height: 30px;\n  margin-left: 10px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  padding: 0 12px;\n  font-family: inherit;\n  font-size: var(--curio-font-size-sm);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.rescan:disabled {\n  opacity: 0.6;\n  cursor: progress;\n}\n\n/* Below a portal's rows: asks it for its next page. */\n.moreRow {\n  display: flex;\n  justify-content: center;\n  padding: 12px 16px;\n}\n\n.moreRow .rescan {\n  margin-left: 0;\n}\n\n/* For the manifest's author: what the source holds that no resource names. */\n.unmatched {\n  margin: 0;\n  padding: 8px 16px;\n  font-size: var(--curio-font-size-sm);\n  color: var(--curio-text-meta);\n}\n\n/* The result list: rows on a card surface, bounded so the page scrolls its\n   results rather than the whole document. */\n.results {\n  background: var(--curio-card-bg);\n  border-top: 1px solid var(--curio-border);\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"identity": `D7x1pUzlYIvHqO3MA_uD`,
	"blurb": `h3eysZ_EyRNJe8vnmhKW`,
	"identityText": `_E5VVssZ_v5QmcwhypFU`,
	"homepage": `K235mtdzVpdt2CpjC6Ze`,
	"count": `qbpdT2dbWvX1lt_IowAl`,
	"rescan": `S6Evzph8Vc7CISxoAMkh`,
	"moreRow": `KRLqo6Ih5epgbuo1brnN`,
	"unmatched": `IWSM1dwj1WBNWVZ4nKRR`,
	"results": `WFerYmCorbIAPWwF2udI`
};
export default ___CSS_LOADER_EXPORT___;
